<div class="smartmove-command-bar smartmove-glass" data-testid="smartmove-command-bar">
  <button
    mat-button
    class="smartmove-command-bar__primary smartmove-focusable"
    type="button"
    aria-label="Ask SmartMove"
    matTooltip="Ask SmartMove"
    (click)="selectPrimaryCommand()"
    data-testid="smartmove-command-primary"
  >
    <mat-icon>{{ primaryCommand.icon }}</mat-icon>
    <span>{{ primaryCommand.label }}</span>
  </button>

  <button
    *ngFor="let command of commands"
    mat-icon-button
    type="button"
    class="smartmove-focusable"
    [attr.aria-label]="command.label"
    [matTooltip]="command.label"
    (click)="commandSelected.emit(command)"
  >
    <mat-icon>{{ command.icon }}</mat-icon>
  </button>
</div>
